import { render, staticRenderFns } from "./CategoryList.vue?vue&type=template&id=5f42603a&"
import script from "./CategoryList.vue?vue&type=script&lang=js&"
export * from "./CategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryList.vue"
export default component.exports